import { render, staticRenderFns } from "./mian.vue?vue&type=template&id=1468fab2&"
import script from "./mian.vue?vue&type=script&lang=js&"
export * from "./mian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports